export const CREATE_RIVIR_TC = '/api/User/create-rivir-tc-eula';

export const CLONE_RIVIR_TC = '/api/User/clone-rivir-tc-eula';

export const DELETE_RIVIR_TC = '/api/User/delete-rivir-tc-eula';

export const GET_USER_RIVIR_TC = '/api/User/get-user-rivir-tc-eula';

export const GET_RIVIR_TC_SHORT_DETAIL =
  '/api/User/get-rivir-tc-eula-short-detail';

export const GET_RIVIR_TC_DETAIL_GRID =
  '/api/User/get-rivir-tc-eula-detail-grid';

export const GET_RIVIR_TC_DETAIL_GRID_DISTINCT =
  '/api/User/get-rivir-tc-eula-detail-grid/distinct';

export const GET_RIVIR_TC_ACCEPTED_GRID =
  '/api/User/rivir-tc-eula-accepted-user-grid';

export const GET_RIVIR_TC_ACCEPTED_GRID_DISTINCT =
  '/api/User/rivir-tc-eula-accepted-user-grid/distinct';

export const RIVIR_TC_GET_ENDPOINT = '/api/User/get-user-rivir-tc-eula';

export const RIVIR_TC_ACCEPT_ENDPOINT = '/api/User/accept-user-rivir-tc-eula';

export const EXPORT_RIVIR_TC_ACCEPTED = '/api/User/export-rivir-tc-accepted-users';
